import { styled } from '@mui/material/styles';

export const ProfileMenuItemWrapper = styled('div')(({ theme }) => {
  return {
    cursor: 'pointer',
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    // '&:hover, &.selected': {
    //   ...theme.mixins.onHover,
    //   color: theme.palette.text.white,
    // },
    transition: 'all 0.12s ease-in-out',
    '&:hover, &.selected': {
      color: theme.palette.text.white,
      backgroundColor: '#5933A080',
    },
  };
});

export const ProfileMenuItemsWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),

  // margin: `0px ${parseInt(theme.spacing(2)) * -1}px`,
}));
